import React from "react"
import { Link } from "gatsby"
import { FontAwesomeIcon } from "@fortawesome/react-fontawesome"
import { faInstagram } from "@fortawesome/free-brands-svg-icons"

const Footer = () => (
  <footer className="footer">
    <div className="footer-inner">
      <div>
        <Link className="footer-brand" to="/">
          CAMECAFE
        </Link>
        <p>東京を中心に活動する、初心者向け写真・カメラサークル</p>
      </div>
      <nav className="footer-links" aria-label="フッターナビゲーション">
        <Link to="/about/">ABOUT</Link>
        <Link to="/blog/event">EVENT</Link>
        <Link to="/gallery/">GALLERY</Link>
        <Link to="/contact/">CONTACT</Link>
      </nav>
      <a
        className="footer-instagram"
        href="https://www.instagram.com/camecafe_circle__.2nd/"
        aria-label="カメカフェのInstagram"
      >
        <FontAwesomeIcon icon={faInstagram} />
      </a>
    </div>
    <div className="footer-meta">
      <span>CAMECAFE / TOKYO</span>
      <span>Since 2019</span>
    </div>
  </footer>
)

export default Footer
